import styled from 'styled-components';
import color from 'tinycolor2';

export const Sidebar = styled.div`
  width: 260px;
  flex: 1 0 260px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  background-color: ${(props) => props.background || props.theme['color.surface']};
  box-shadow: ${(props) => props.shadow || (props.theme.themeId === 'extra-light' ? '1px 0 2px 0 rgba(0,0,0,0.1)' : 'none')};
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;

  ${(props) => props.newUX && `
  width: 264px;
  flex: 1 0 264px;
  background-color: ${props.theme.themeId === 'extra-light' ? props.theme['color.white'] :
    props.theme['color.blackDark']};
  justify-content: unset;
  box-shadow: none;
  `}

  &::-webkit-scrollbar-track {
    background: none;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0).toString()};
    border: 4px solid transparent;
    background-clip: padding-box;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0.2).toString()};
    border: 4px solid transparent;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }

  ${(props) => !props.newUX && `@media (max-width: ${props.theme['media.tablet']}px) {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    transform: ${props.mobileSidebarOpen ? 'none' : 'translate3d(-100%, 0, 0)'};
    z-index: 2048;
  }`}
`;

export const SidebarOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${(props) => color(props.theme['color.black']).setAlpha(0.7).toString()};
  opacity: ${({ status }) => status === 'entering' || status === 'entered' ? 1 : 0};
  transition: opacity 0.4s ease;
  z-index: 2048;
`;
